import {
  Button,
  Empty,
  Input,
  Popconfirm,
  Select,
  Space,
  Spin,
  Table,
  Tag,
  Typography,
} from "antd";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../app/store";
import { getUserDatas } from "./slice";
import { DataKitchenParam } from "../../../../apis/model/kitchen.model";
import kitchenAdmin from "../../../../apis/admin/kitchenService";
import notificationHandler from "../../../atoms/Notification";
import {
  DeleteOutlined,
  FormOutlined,
  LoadingOutlined,
  PlusCircleOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import "./kitchen.scss";

const ListKitchen = () => {
  const { kitchens }: any = useSelector(
    (state: RootState) => state.kitChenList
  );
  const [status, setStatus] = React.useState<any>("");
  const [values, setValue] = React.useState<any>("");
  const [loading, setLoading] = React.useState(false);
  const [currentPage, setCurrentPage] = React.useState(1);
  // const [inputValue, setInputValue] = React.useState('');
  const infoUserString = localStorage.getItem("user_info");
  const infoUser = infoUserString ? JSON.parse(infoUserString) : "";
  const isSuperAdmin = infoUser.roles.indexOf("SUPER_ADMIN") !== -1;

  const handlePageChange = (page: any) => {
    setCurrentPage(page);
  };

  const [pageSize, setPageSize] = React.useState(10);

  const displayedIndex = (index: any) =>
    (currentPage - 1) * pageSize + index + 1;

  const dispatch = useDispatch<AppDispatch>();
  const { Search } = Input;
  const customButton = (
    <Button className="border-none mr-3" icon={<SearchOutlined />} />
  );

  const { Title } = Typography;

  useEffect(() => {
    setLoading(true);
    dispatch(getUserDatas({ status, value: values }))
      .then(() => {})
      .catch((err: any) => {
        notificationHandler("error", err.response.data.data.msg_content);
      })
      .finally(() => setLoading(false));
  }, [dispatch]);

  const antIcon = (
    <LoadingOutlined style={{ fontSize: 70, position: "fixed" }} spin />
  );

  const handleRemove = (id: any) => {
    setLoading(true);
    kitchenAdmin
      .removeKitchen(id)
      .then(() => {
        dispatch(getUserDatas({ status, value: values }));
        notificationHandler("success", "Xóa bếp ăn thành công!");
        setLoading(false);
      })
      .catch((err) => {
        notificationHandler("error", err.response.data.data.msg_content);
        setLoading(false);
      });
  };
  const onSearch = (value: string) => {
    setValue(value);
    dispatch(getUserDatas({ status, value: value }))
      .unwrap()
      .then((e) => {
        setCurrentPage(1);
      });
  };
  const handleSearchStatus = (value: string) => {
    if (value == undefined) value = "";
    setStatus(value);
    dispatch(getUserDatas({ status: value, value: values }))
      .unwrap()
      .then((item) => {
        setCurrentPage(1);
      });
  };

  const columns: any = [
    {
      title: "STT",
      dataIndex: "index",
      key: "index",
      align: "center",
      width: "2%",
      render: (_: any, __: any, index: any) => displayedIndex(index),
    },
    {
      title: "Tên bếp ăn",
      dataIndex: "kitchenName",
      width: "15%",
      align: "center",
      key: "kitchenName",
      sorter: (a: any, b: any) => a.kitchenName.localeCompare(b.username),
      render: (kitchenName: string) => {
        return (
          <div className="truncates mx-auto" title={kitchenName}>
            {kitchenName}
          </div>
        );
      },
    },
    {
      title: "Địa chỉ",
      dataIndex: "kitchenAddress",
      align: "center",
      key: "kitchenAddress",
      width: "15%",
      render: (kitchenAddress: string) => {
        return (
          <div className="truncates mx-auto" title={kitchenAddress}>
            {kitchenAddress}
          </div>
        );
      },
    },
    {
      title: "Giá ",
      dataIndex: "mealPrice",
      align: "center",
      key: "mealPrice",
      width: "10%",
      render: (value: any, record: any, index: number) => {
        const mealPrice = value.toLocaleString("vi", {
          style: "currency",
          currency: "VND",
        });
        return <div>{mealPrice}</div>;
      },
      sorter: (a: any, b: any) => a.mealPrice - b.mealPrice,
    },
    {
      title: "Trạng thái",
      key: "status",
      dataIndex: "status",
      align: "center",
      width: "8%",
      render: (status: number, record: any, index: number) => {
        let color = "green";
        let color1 = "volcano";
        let text1 = "Hoạt động";
        let text = "Không hoạt động";
        return (
          <div className="mx-auto">
            {status === 1 && (
              <Tag color={color} key={status} className="py-1">
                {text1}
              </Tag>
            )}
            {status === 0 && (
              <Tag color={color1} key={status} className="py-1">
                {text}
              </Tag>
            )}
            {status === 0 && ""}
          </div>
        );
      },
    },
    {
      title: "Số điện thoại",
      dataIndex: "contactPhoneNumber",
      key: "contactPhoneNumber",
      align: "center",
      width: "15%",
    },
    {
      title: "Tên quản lý",
      dataIndex: "contactName",
      align: "center",
      key: "contactName",
      width: "15%",
      sorter: (a: any, b: any) => a.contactName.localeCompare(b.contactName),
      render: (contactName: string) => {
        return (
          <div className="truncates mx-auto" title={contactName}>
            {contactName}
          </div>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      align: "center",
      key: "email",
      width: "10%",
      render: (email: string) => {
        return (
          <div className="truncates mx-auto" title={email}>
            {email}
          </div>
        );
      },
    },
    {
      title: "Mã nhân viên",
      dataIndex: "contactCode",
      align: "center",
      key: "contactCode",
      width: "8%",
      render: (contactCode: string) => {
        return (
          <div className="truncates mx-auto" title={contactCode}>
            {contactCode}
          </div>
        );
      },
    },
    {
      title: "Hành động",
      dataIndex: "action",
      key: "action",
      align: "center",
      width: "8%",
      render: (text: string, record: DataKitchenParam) => {
        return (
          <Space size="small">
            <Button className="mr-1 hover:border-[#FAAD14] hover:text-[#FAAD14] bg-[#FAAD14] border-[#FAAD14] p-[5px_10px] text-white ">
              <Link
                to={`/admin/editKitchen/${record.id}`}
                className="flex items-center"
              >
                <FormOutlined className="mr-1" />
                Sửa
              </Link>
            </Button>
            <Popconfirm
              title="Bạn có muốn xóa bếp ăn?"
              okText="có"
              onConfirm={() => handleRemove(record.id)}
              cancelText="Không"
              okType="danger"
            >
              <Button
                danger
                className="bg-[#ff4d4f] text-white "
                loading={loading}
              >
                <div className="flex items-center">
                  <DeleteOutlined className="pr-1" />
                  Xóa
                </div>
              </Button>
            </Popconfirm>
          </Space>
        );
      },
    },
  ];

  return (
    <div id="kitchen">
      <Spin indicator={antIcon} spinning={loading} />
      <div className="flex justify-between">
        <div className="flex w-[80%] header-select">
          <Input
            style={{ width: "30%" }}
            placeholder="Nhập tên tìm kiếm"
            maxLength={200}
            onChange={(e) => onSearch(e.target.value)}
            onBlur={(e) => setValue(e.target.value.trim())}
            prefix={<SearchOutlined />}
            allowClear
            value={values}
          />
          <Select
            style={{ width: "200px" }}
            className="ml-3"
            onChange={handleSearchStatus}
            placeholder={"Chọn trạng thái"}
            allowClear
            options={[
              // { value: "", label: "Chọn trạng thái" },
              { value: 0, label: "Không hoạt động" },
              { value: 1, label: "Hoạt động" },
            ]}
          />
        </div>
        {isSuperAdmin && (
          <Button className="p-[5px_15px] border-green-600 hover:border-green-600 hover:text-green-600 hover:bg-white bg-green-600 text mb-4 rounded-sm  text-white">
            <Link
              to={"/admin/createKitchen"}
              className="flex items-center hover:text-white"
            >
              <PlusCircleOutlined className="mr-1" />
              Thêm mới
            </Link>
          </Button>
        )}
      </div>
      <Title className="mt-[15px]" level={3}>
        Danh sách bếp ăn
      </Title>
      <Table
        dataSource={kitchens}
        columns={columns}
        pagination={{
          current: currentPage,
          locale: { items_per_page: "bản ghi / Trang" },
          defaultPageSize: 10,
          onChange: handlePageChange,
          showSizeChanger: true,
          pageSizeOptions: ["10", "20", "50"],
          onShowSizeChange(current, size) {
            setPageSize(size);
          },
          showTotal: (total: any, range: any) =>
            `${range[0]}-${range[1]} Tổng ${total} bản ghi`,
        }}
        rowKey={(record: any) => record.id}
        className="overflow-auto mt-[15px]"
        locale={{
          emptyText: (
            <Empty
              image={Empty.PRESENTED_IMAGE_DEFAULT}
              description="Không có dữ liệu!"
            />
          ),
        }}
      />
    </div>
  );
};

export default ListKitchen;
